




























import { createStoreModule } from './store';
import { mapActions, mapState } from 'vuex';
import { LoaderMixin } from '@/pages/profile/mixins';
import { Warning } from '@/pages/profile/components';
import PurchaseEventCard from '@/pages/profile/blocks/cards/purchaseEventCard/PurchaseEventCard.vue';
import InfoText from '@/components/parts/infotext';
import { StatusEnum } from '@/pages/profile/mixins';
import { AppErrorsBlock } from '@/uikit/components';
import { Paginator } from '@/components/parts/pagination';
import PurchasesHidePurchaseRequestController from '@/pages/profile/views/purchases/components/PurchasesHidePurchaseRequestController.vue';

const STORE_MODULE_NAME = 'purchasesEvent';
const FETCH_ITEMS = 'fetch';

const LIMITS = ['10', '15', '30'];
const PAGE_SIZE = LIMITS[0];
const PAGE_NUMBER = 1;
const getPageSize = (value?: string) => value || PAGE_SIZE;

export default {
  name: 'PurchasesEvent',
  storeRegister: createStoreModule,
  storeName: STORE_MODULE_NAME,
  mixins: [LoaderMixin],

  components: {
    PurchasesHidePurchaseRequestController,
    Paginator,
    Warning,
    InfoText,
    PurchaseEventCard,
    AppErrorsBlock,
  },

  computed: {
    ...mapState(STORE_MODULE_NAME, [
      'items',
      'page',
      'pageCount',
      'count',
      'limit',
      'title',
      'errorMessage',
      'errors',
    ]),
  },

  metaInfo() {
    return {
      title: this.title,
    };
  },

  // NOTY: можно это запихать в asyncData({ store, route }), но в профиле нет смысла
  // NOTY: при попытке так сделать вы нарвётесь на 401 (not authorized на стороне ноды т.к. нода не копирует куки при запросах через неё, а в них токен юзера)
  watch: {
    '$route.query': {
      handler() {
        this.fetchItems();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    ...mapActions(STORE_MODULE_NAME, ['fetch', 'postClose', 'orderHide']),
    async fetchItems() {
      const query = { ...this.$route.query };
      const params = {
        page: query.page || PAGE_NUMBER,
        limit: getPageSize(query.limit),
        ...this.$route.query,
        ...this.$route.params,
      };
      this.status = StatusEnum.LOADING;
      await this.$store.dispatch(`${STORE_MODULE_NAME}/${FETCH_ITEMS}`, params);
      this.status = StatusEnum.SUCCESS;
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/purchases/pages/purchases-event/Index.vue